export class PieChartDataModel {
    label: string;
    value: number;
    color: string;
    legendValue: any;
}
